export default {
  MyWaitingApproval: "Của tôi chờ duyệt",
  NeedToDo: "Tôi cần thực hiện",
  SearchRequest: "Tìm kiếm theo mã lượt, tiêu đề kiến nghị",
  SearchRequestType: "Tìm kiếm loại đề xuất",
  RequestName: "Tiêu đề kiến nghị",
  RequestType: "Loại đề xuất",
  Requester: "Người tạo",
  JobPositionName: "Vị trí của người tạo",
  OrganizationUnitName: "Phòng ban của người tạo",
  RequestDate: "Ngày tạo",
  Status: "Trạng thái",
  Sender: "Người gửi",
  Approver: "Người phê duyệt",
  SelectRequestTypeToContinue: "Chọn một loại đề xuất để tiếp tục",
  RequestGroup: "Nhóm đề xuất",
  RequestFavourite: "Yêu thích",
  Period: "Thời hạn",
  Passed: "Đồng ý",
  Rejected: "Đã từ chối",
  Canceled: "Đã hủy",
  Complete: "Hoàn thành",
  MyCreate: "Đề xuất đã tạo",
  MyExecute: "Số lượt thực hiện",
  ViewChart: "Xem biểu đồ"
};
